<template>
  <div class="bbp-project-form" v-if="clientsListProjects.length > 0 && usersListProjects.length > 0">
    <BBPForm @close="closeForm"
             @save="saveForm"
             @update="checkProjectType"
             :btnTextRight="project.id ? 'SAVE' : 'ADD'"
             :defaultModel="project"
             :disabledButton="disabledButton"
             :title="titleForm"
             :project="project"
             :inputs="inputs"/>
  </div>
</template>

<script>
import projectInputs from '@/constants/InputsSettings/projectInputs'
import BBPForm from '@/components/Main/BBPForm/BBPForm'
import ProjectsApi from '@/api/Projects/api'
import ClientApi from '@/api/Clients/api'
import UserApi from '@/api/Users/api'
import TypeServiceProjectApi from '@/api/TypeServiceProject/api'
import StepServiceProjectApi from '@/api/StepServiceProject/api'
import ProjectsListTags from '@/api/ProjectsListTags/api'
import {findIndex, find, filter, cloneDeep, get} from 'lodash'
import setProjectFullInfo from '@/mixin/setProjectFullInfo'
import setProjectBody from '@/mixin/setProjectBody'
import filterByDepartment from '@/mixin/filterByDepartment'
import {HOURLY} from '@/constants/projectTypes'
import {departmentCategory} from '@/constants/departmentCategory'
import getWithElasticsearch from '@/mixin/getWithElasticsearch'

export default {
  name: 'BBPProjectForm',
  components: {BBPForm},
  mixins: [setProjectFullInfo, setProjectBody, getWithElasticsearch, filterByDepartment],
  props: ['project', 'subproject'],
  data () {
    return {
      disabledButton: false,
      checkedKPI: false,
      inputsList: []
    }
  },
  computed: {
    inputs: {
      get () {
        if (!this.project.id) {
          return this.inputsList.filter(item => !item.haveFact)
        }
        const approvedStatus = get(this.project, 'approveStatus', '')
        const disabledInputsInvoice = ['currentAmount', 'includeOfKpi', 'businessConsultant']
        return this.inputsList.filter(item => {
          if (this.project.invoiceId && !approvedStatus) {
            item.disabled = disabledInputsInvoice.includes(item.model)
          } else if (this.project.invoiceId && approvedStatus) {
            disabledInputsInvoice.push('factValue', 'projectManager', 'kpiHelpUsers')
            item.disabled = disabledInputsInvoice.includes(item.model)
          }
          if (item.model === 'projectType') item.isHideRow = true
          if (this.project.invoiceId) {
            return !item.hideTextarea
          }
          return item
        })
      },
      set (data) {
        this.inputsList = data
      }
    },
    titleForm () {
      const defaultTitle = this.subproject ? 'Add Subproject' : 'Add project'
      return this.project.id ? this.project.name : defaultTitle
    },
    userInfo () {
      return this.$store.getters.userInfo
    },
    projectsList: {
      get () {
        return this.$store.getters.projectsList
      },
      set (data) {
        this.$store.dispatch('setProjectsList', data)
      }
    },
    clientsListProjects: {
      get () {
        return this.$store.getters.clientsListProjects
      },
      set (data) {
        this.$store.dispatch('setClientsListProjects', data)
      }
    },
    usersListProjects: {
      get () {
        return this.$store.getters.usersListProjects
      },
      set (data) {
        this.$store.dispatch('setUsersListProjects', data)
      }
    },
    tags: {
      get () {
        return this.$store.getters.tags
      },
      set (data) {
        this.$store.dispatch('setTags', data)
      }
    },
    typeServiceList: {
      get () {
        return this.$store.getters.typeServiceList
      },
      set (data) {
        this.$store.dispatch('setTypeServiceList', data)
      }
    }
  },
  methods: {
    closeForm () {
      this.$emit('close')
    },
    saveForm (val) {
      const { supportManager, contactPm } = this.project
      if (this.disabledButton) return
      val = {
        ...val,
        supportManager,
        contactPm
      }
      const result = this.setProjectBody(val, this.subproject)
      const updateResult = this.updateStepServiceProject(result, val)
      this.$emit('loader', true)
      result.id ? this.editProject(updateResult) : this.createProject(updateResult)
    },
    updateStepServiceProject (result, val) {
      const { typeServiceProject = {} } = this.project
      if (typeServiceProject === null) return result
      const { typeServiceProject: typeServiceProjectVal = {} } = val
      if (typeServiceProject._id !== typeServiceProjectVal._id) result.stepServiceProject = null
      return result
    },
    checkDisable (model) {
      const valueComment = get(model, 'managerComment', '')
      const currentValue = get(model, 'currentAmount', 0)
      const factValue = get(model, 'factValue', 0)
      const result = factValue !== 0 ? !valueComment && currentValue !== factValue : false
      return result
    },
    createProject (project) {
      ProjectsApi.createProject(project)
        .then(async ({data}) => {
          const newData = await this.getStepServiceProject(data)
          const project = await this.setProjectFullInfo(newData)
          this.$emit('updateFullInfo', project)
          if (!this.subproject) {
            this.projectsList.unshift(project)
          } else {
            this.$emit('update', project)
          }
          this.$emit('loader', false)
          this.closeForm()
        })
        .catch((err) => {
          this.$emit('loader', false)
          console.error(err)
        })
    },
    editProject (project) {
      const index = findIndex(this.projectsList, {id: project.id})
      ProjectsApi.editProject(project)
        .then(async ({ data }) => {
          const project = await this.setProjectFullInfo(data)
          if (index !== -1 && !this.subproject) this.projectsList.splice(index, 1, project)
          this.$emit('loader', false)
          this.closeForm()
        })
        .catch((err) => {
          this.$emit('loader', false)
          console.error(err)
        })
    },
    checkProjectType ({input, value, model}) {
      if (input.model === 'includeOfKpi') this.checkedKPI = value
      this.disabledButton = this.checkDisable(model)
      if (input.model !== 'projectType') return
      this.setRequiredAmount(value !== HOURLY.id)
    },
    setRequiredAmount (value) {
      const amount = find(this.inputs, {model: 'amount'})
      if (amount) amount.required = value
    },
    setUsersPmBmInputs () {
      const projectManagers = this.inputs.find((i) => i.model === 'projectManager')
      const businessConsultants = this.inputs.find((i) => i.model === 'businessConsultant')

      const { PROJECT_MANAGER, BUSINESS_CONSULTANT } = departmentCategory
      projectManagers.options = this.sortUsersByDepartment(this.usersListProjects, PROJECT_MANAGER)
      businessConsultants.options = this.sortUsersByDepartment(this.usersListProjects, BUSINESS_CONSULTANT)
    },
    async getUsersListSelect () {
      if (this.usersListProjects.length) {
        this.setUsersPmBmInputs()
        return
      }

      try {
        const { data } = await UserApi.getUsersListSelect({})
        this.usersListProjects = data
        this.setUsersPmBmInputs()
      } catch (err) {
        console.error(err)
      }
    },
    setSubprojectInputs () {
      this.inputs = this.getInputs()
      if (!this.subproject) return
      this.inputs = filter(this.inputs, item => !item.hideSubproject).map(item => {
        if (item.model === 'client') item.disabled = true
        return item
      })
    },
    getInputs () {
      return cloneDeep(projectInputs).map(input => {
        const isAutoProject = this.project && this.project.invoiceId
        const isProjectNotPaid = this.project && this.project.currentValue < this.project.amount
        if (isAutoProject && isProjectNotPaid && input.model === 'amount') input.disabled = true
        return input
      })
    },
    setClientsInputs () {
      const input = this.inputs.find((i) => i.model === 'client')
      if (input) input.options = this.clientsListProjects
    },
    setTagsInputs () {
      const input = this.inputs.find((i) => i.type === 'selectTag')
      if (input) input.options = this.tags
    },
    setTypeServiceListInputs () {
      const input = this.inputs.find((i) => i.model === 'typeServiceProject')
      if (input) input.options = this.typeServiceList
    },
    async getTypeServiceProject () {
      if (this.typeServiceList.length) {
        this.setTypeServiceListInputs()
        return
      }
      try {
        const { data } = await TypeServiceProjectApi.getTypeServiceProject()
        this.typeServiceList = data
        this.setTypeServiceListInputs()
      } catch (err) {
        console.error(err)
      }
    },
    async getStepServiceProject (project) {
      const { typeServiceProject = {}, client } = project
      if (typeServiceProject === null) {
        return {
          ...project,
          client: {
            ...client,
            _id: client.id
          },
          totalPercent: 0
        }
      }
      const { _id } = typeServiceProject
      try {
        const { data } = await StepServiceProjectApi.getStepServiceProject(_id)
        return {
          ...project,
          totalPercent: 0,
          client: {
            ...client,
            _id: client.id
          },
          typeServiceProject: {
            ...typeServiceProject,
            stepServiceProject: data
          }
        }
      } catch (err) {
        console.error(err)
        return project
      }
    },
    async getTags () {
      if (this.tags.length) {
        this.setTagsInputs()
        return
      }
      try {
        const { data } = await ProjectsListTags.getTags()
        this.tags = data
        this.setTagsInputs()
      } catch (err) {
        console.error(err)
      }
    },
    async getClientsSelect () {
      if (this.clientsListProjects.length) {
        this.setClientsInputs()
        return
      }
      try {
        const { data } = await ClientApi.getClientsSelect({contactType: 'contactType[]=1'})
        this.clientsListProjects = data
        this.setClientsInputs()
      } catch (err) {
        console.error(err)
      }
    }
  },
  beforeMount () {
    this.setSubprojectInputs()
    this.getClientsSelect()
    this.getUsersListSelect()
    this.getTypeServiceProject()
    this.getTags()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbp-project-form {
    display: grid;
    width: 520px;
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/Projects/ListOfProjects/BBPProjectForm.vue